class Share {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.url = self.elem.getAttribute('data-share-url');
        self.title = self.elem.getAttribute('data-share-title');
    }

    init() {
        let self = this;

        self.elem.addEventListener('click', evt => {
            if (navigator.share) {
                evt.preventDefault();

                navigator.share({
                    title: self.title,
                    url: self.url
                }).then(() => {
                    // success

                }).catch(() => {
                }
                    
                );
            }
        });
    }
}

export default Share;